import { getCountryFlagSvgSource } from '@yembo/yemblocks-core/dist/_util';
import { locales } from '../../_util/locales';

export const languages = locales.map(({ language, locale }) => ({
  label: language,
  locale,
  flag: locale.split('-').pop()?.toLowerCase(),
  flagUrl: getCountryFlagSvgSource(locale.split('-').pop()?.toLowerCase()),
}));

export const DEFAULT_LANGUAGE = languages[0];
